import React from 'react';
import * as ReactVirtualized from 'react-virtualized';

import {
  Paper,
  View,
  Stack,
  Divider,
  Typography,
  LegacyPagination,
  IconButton,
  CloseIcon,
  makeStyles,
} from '@gogame/components';
import { DataGridContainer } from '@gogame/data-grid';

import TileList from './TileList';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
    },
    grid: {
      overflow: 'auto',
    },
    view: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
    },
    stack: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
    },
    selectedToolbar: {
      padding: 12,
      flexDirection: 'row',
      justifyContent: 'space-between',
      background: theme.palette.action.hover,
    },
    footer: {
      borderTop: `1px solid  ${theme.palette.divider}`,
    },
  }),
  { name: 'Ggtiles' }
);

const Tiles = ({
  toolbarComponent,
  selectableRowToolbarComponent,
  tileComponent,
  tileProps,
  rows,
  isLoading,
  isRefetching,
  onChangeSettings,
  count,
  limit,
  offset,
  height,
  selectedRowsCount,
  onUnselectAll,
}) => {
  const classes = useStyles();

  const hasToolbar = !!(toolbarComponent || selectableRowToolbarComponent);
  return (
    <DataGridContainer minHeight={height}>
      <Paper variant={'outlined'} className={classes.root} data-cy={'tiles'}>
        <Stack direction={'column'} g={'100%'} className={classes.stack}>
          {hasToolbar ? (
            selectedRowsCount ? (
              <Stack className={classes.selectedToolbar}>
                <Stack direction={'row'} spacing={2} alignItems={'center'}>
                  <IconButton
                    icon={<CloseIcon />}
                    onClick={onUnselectAll}
                    tooltip={'Unselect all'}
                  />
                  <Typography variant={'subtitle1'}>
                    {`${selectedRowsCount} selected`}
                  </Typography>
                </Stack>
                {selectableRowToolbarComponent}
              </Stack>
            ) : (
              toolbarComponent
            )
          ) : null}
          <Divider />
          <View
            loading={isLoading}
            fetching={isRefetching}
            className={classes.view}
          >
            {rows?.length ? (
              <Stack flex={'1 1 auto'}>
                <ReactVirtualized.AutoSizer>
                  {({ width, height }) => {
                    const columns = Math.ceil(width / 340);
                    return (
                      <TileList
                        tileComponent={tileComponent}
                        tileProps={tileProps}
                        rows={rows}
                        width={width}
                        height={height}
                        columns={columns}
                      />
                    );
                  }}
                </ReactVirtualized.AutoSizer>
              </Stack>
            ) : !isLoading ? (
              <Stack
                p={2}
                justifyContent={'center'}
                alignItems={'center'}
                direction={'row'}
                flex={'1 1 auto'}
              >
                <Typography color={'textSecondary'}>No records</Typography>
              </Stack>
            ) : null}
          </View>
          {count && limit ? (
            <Stack p={1} justifyContent={'flex-end'} className={classes.footer}>
              <LegacyPagination
                limit={limit}
                offset={offset}
                count={count}
                onChange={onChangeSettings}
              />
            </Stack>
          ) : null}
        </Stack>
      </Paper>
    </DataGridContainer>
  );
};

export default Tiles;
